import { render, staticRenderFns } from "./KameDocuments.vue?vue&type=template&id=2d054987&"
import script from "./KameDocuments.vue?vue&type=script&lang=js&"
export * from "./KameDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports